import React, { useContext } from "react";
import { RoleCtx } from "../../../lib/context";
import { useHistory, useParams } from 'react-router-dom';
import ConferenceSettings from "../ConferenceSetting";

const ConfSettings = (props) => {
    const { role } = useContext(RoleCtx);
    const { id, uid } = useParams();
    const history = useHistory();

    return <ConferenceSettings role={role} id={id} uid={uid} history={history} />
}
export default ConfSettings;

